<template>
  <div class="class-list">
    <div class="GlobalInfoBar">
      <div class="info-bar-container">
        <div class="info-bar">
          <img class="info-bar_icon" src="@/assets/images/icon_sjlb_@2x.png" alt />
          <div class="info-bar_content">
            <h5>平台收入账户-撮合服务费收入账户</h5>
            <span>
              查看<span style="color: #0981FF;">撮合服务费</span>的账单
            </span>
          </div>
        </div>
      </div>
    </div>
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <From :modeList="modeList" />
      </div>
      <Table ref="table" :modeList="modeList" />
    </GlobalChunk>
  </div>
</template>

<script>
import From from "./Form";
import Table from "./Table";
import { http } from "@/utils/request/revenue"

export default {
  components: {
    From,
    Table,
  },
  data() {
    return {
      modeList: [],

    };
  },
  created() {
    http.getAccountNoList({
      pageType: '04',
    }).then(res => {
      if (res.code === 1) {
        // 2026.5.15 屏蔽“渠道服务费”
        this.modeList = (res.data || []).filter(item => item.key !== 'channel_service_fee')
      }
    })
  },
  methods: {

  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.right_code {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-left: 10px;
  width: 320px;
  height: 66px;
  background: #feeaeb;
  border-radius: 8px 33px 33px 8px;

  .rc_left {
    font-size: 16px;
    font-family: FZLanTingHei-B-GBK;
    font-weight: bold;
    color: #333333;
  }

  .foot_text {
    text-align: center;
    font-size: 12px;
    font-family: FZLanTingHei-R-GBK;
    font-weight: 400;
    color: #333333;
  }

  .rr_top {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-family: FZLanTingHei-B-GBK;
    font-weight: bold;
    color: #ff4949;
  }

  .copy_code {
    cursor: pointer;
    margin-left: 5px;
    text-align: center;
    width: 30px;
    height: 16px;
    background: #ff4949;
    border-radius: 3px;
    font-size: 12px;
    font-family: FZLanTingHeiS-R-GB;
    font-weight: 400;
    color: #ffffff;
    line-height: 16px;
  }
}

.code_content {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.info-bar-container {
  margin-bottom: 20px;

  .info-bar {
    padding: 10px 20px 10px 20px;
    background: #e4ecfd;
    border-radius: 33px;
    display: flex;
    align-items: center;

    &_icon {
      width: 40px;
      height: 40px;
      margin-right: 8px;
    }

    &_content {
      >h5 {
        font-size: 18px;
        font-weight: 700;
        color: #242d3e;
        line-height: 20px;
        margin-bottom: 5px;
      }

      >span {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }
  }

  .text-on {
    color: #ff687b;
  }
}

.info-bar-container_oder {
  flex: 1;

  .info-bar {
    padding: 10px 20px 10px 20px;
    background: #e4ecfd;
    border-radius: 33px 0 0 33px;
    display: flex;
    align-items: center;

    &_icon {
      width: 40px;
      height: 40px;
      margin-right: 8px;
    }

    &_content {
      >h5 {
        font-size: 18px;
        font-weight: 700;
        color: #242d3e;
        line-height: 20px;
        margin-bottom: 5px;
      }

      >p {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }
  }

  .text-on {
    color: #ff687b;
  }
}

.hint-container {
  .info-bar {
    padding: 4px 10px 4px 10px;
    background: #ffebeb;
    border-radius: 25px;
    position: relative;

    &_icon {
      width: 22px;
      height: 22px;
      margin-right: 11px;
    }

    &_content {
      >h5 {
        font-size: 14px;
        font-weight: 400;
        color: #ff8080;
        margin-bottom: 0;
      }

      >p {
        font-size: 14px;
        font-weight: 400;
        color: #242d3e;
      }
    }

    .iphone-info {
      position: absolute;
      right: 22px;
      font-size: 14px;
      font-weight: 400;
      color: #242d3e;
      display: flex;
      align-items: center;

      &_icon {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }
    }
  }
}

.GlobalInfoBar {
  position: relative;
}

.rotate-image {
  width: 36px;
  height: 36px;
  transition: transform 0.5s;
}

.rotate-image.rotate {
  animation: rotate360 1s linear;
}

@keyframes rotate360 {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.class-list {
  .button_top {
    cursor: pointer;
    margin-bottom: 20px;
    ;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .faultBtn {
    width: 750px;
    height: 32px;
    background: #F9FBFD;
    border: 1px solid #C1D1FF;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;

    .active {
      text-align: center;
      color: white;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 30px;
      height: 30px;
      background: #0981FF;
      border-radius: 20px;
    }

    .none {
      text-align: center;
      color: #333;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 30px;
      height: 30px;
      border-radius: 20px;
    }
  }
}
</style>
